import * as Sentry from "@sentry/react";
import { SystemError } from "../../errors/sentryErrors";
import { TRIP_PLAN_KEY } from "./constants";

export const getStoredPlan = () => {
  try {
    const stored = sessionStorage.getItem(TRIP_PLAN_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (err) {
    Sentry.withScope((scope) => {
      scope.setTag("feature", "system");
      scope.setTag("app", "web");
      scope.setTag("error_source", "browser");
      Sentry.captureException(new SystemError(err instanceof Error ? err.message : String(err)));
    });
    return null;
  }
};

export const setStoredPlan = (data) => {
  sessionStorage.setItem(TRIP_PLAN_KEY, JSON.stringify(data));
};

export const clearStoredPlan = () => {
  sessionStorage.removeItem(TRIP_PLAN_KEY);
};

try {
  if (typeof window !== 'undefined' && localStorage.getItem(TRIP_PLAN_KEY)) {
    localStorage.removeItem(TRIP_PLAN_KEY);
  }
} catch (err) {
  Sentry.withScope((scope) => {
    scope.setTag("feature", "system");
    scope.setTag("app", "web");
    scope.setTag("error_source", "browser");
    Sentry.captureException(new SystemError(err instanceof Error ? err.message : String(err)));
  });
}
